import BoxCancelIconPath from "@ingka/ssr-icon/paths/box-cancel";

export default BoxCancelIconPath;
